import {
    AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
    Paper, Badge, Drawer, Divider, Switch, FormControlLabel
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';

const Tablesnavbar = () => {
    const navigate = useNavigate();
    const [showContainer, setShowContainer] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isOnline, setIsOnline] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const isMobile = useMediaQuery('(max-width:600px)');

    // ✅ Logout
    const handleLogout = async () => {
        try {
            const authToken = localStorage.getItem("authToken");

            await axios.post(
                "https://backend.maamaas.com/food/api/auth/logout",
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            console.log("✅ Logged out successfully from backend");
        } catch (error) {
            console.error("❌ Logout API failed:", error);
        } finally {
            localStorage.removeItem("authToken");
            localStorage.removeItem("vendorId");
            setShowContainer(false);
            setDrawerOpen(false);
            navigate("/");
        }
    };

    // ✅ Fetch Cart Data
    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            let items = [];
            let count = 0;

            if (Array.isArray(response.data.cartItems)) {
                const dineInItems = response.data.cartItems.filter(
                    item => item.orderType === "DINE_IN"
                );
                items = dineInItems;
                count = dineInItems.length;
            } else if (typeof response.data.cartItemsCount === "number") {
                count = response.data.cartItemsCount;
            } else if (typeof response.data === "number") {
                count = response.data;
            }

            setCartItems(items);
            setCartCount(count);
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    // ✅ Fetch Vendor Status (Open/Closed)
    const fetchVendorStatus = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data && typeof response.data.online === "boolean") {
                setIsOnline(response.data.online);
            }
        } catch (error) {
            console.error("Error fetching vendor status:", error);
        }
    };

    // ✅ Toggle Vendor Status
    const handleToggleStatus = async (event) => {
        const newStatus = event.target.checked;
        setIsOnline(newStatus);

        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            await axios.put(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { online: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            console.log("✅ Vendor status updated:", newStatus);
        } catch (error) {
            console.error("Error updating vendor status:", error);
        }
    };

    useEffect(() => {
        fetchCartData();
        fetchVendorStatus();
    }, []);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const DrawerContent = (
        <Box sx={{ width: 250, padding: 2 }} role="presentation">
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>
            <Divider />
        </Box>
    );

    return (
        <>
            <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1300 }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* ✅ Logo */}
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", color: "#fff", fontSize: "26px", cursor: "pointer" }}
                        onClick={() => navigate("/foodladingpage")}
                    >
                        MAAMAA'S
                    </Typography>

                    {/* ✅ Right Section */}
                    {isMobile ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Link to="/tableCart">
                                <IconButton sx={{ color: "white" }}>
                                    <Badge
                                        badgeContent={cartCount}
                                        color="error"
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#4e4d4b',
                                                color: 'white',
                                                borderRadius: '4px',
                                                padding: '0 6px',
                                                minWidth: '20px',
                                                height: '20px',
                                            }
                                        }}
                                    >
                                        <ShoppingCartIcon fontSize="large" />
                                    </Badge>
                                </IconButton>
                            </Link>

                            <IconButton onClick={() => setShowContainer(!showContainer)} sx={{ color: "white" }}>
                                <AccountCircleIcon fontSize="large" />
                            </IconButton>
                        </Box>
                    ) : (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                            {/* ✅ Online/Offline Toggle */}
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isOnline}
                                        onChange={handleToggleStatus}
                                        color="primary"
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#fff',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#fff',
                                            },
                                            '& .MuiSwitch-switchBase': {
                                                color: '#fff',
                                            },
                                            '& .MuiSwitch-track': {
                                                backgroundColor: '#fff',
                                            }
                                        }}
                                    />
                                }
                                label={isOnline ? "Open" : "Closed"}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    color: "#fff",
                                    marginTop: "3px"
                                }}
                            />

                            {/* ✅ Cart */}
                            <Link to="/tableCart">
                                <IconButton sx={{ color: "white" }}>
                                    <Badge
                                        badgeContent={cartCount}
                                        color="error"
                                        sx={{
                                            '& .MuiBadge-badge': {
                                                backgroundColor: '#4e4d4b',
                                                color: 'white',
                                                borderRadius: '4px',
                                                padding: '0 6px',
                                                minWidth: '20px',
                                                height: '20px',
                                            }
                                        }}
                                    >
                                        <ShoppingCartIcon fontSize="large" />
                                    </Badge>
                                </IconButton>
                            </Link>

                            {/* ✅ Account */}
                            <IconButton onClick={() => setShowContainer(!showContainer)} sx={{ color: "white" }}>
                                <AccountCircleIcon fontSize="large" />
                            </IconButton>
                        </Box>
                    )}
                </Toolbar>

                {/* ✅ Account Menu */}
                {showContainer && (
                    <Paper
                        sx={{
                            position: "absolute",
                            top: "60px",
                            right: "10px",
                            width: "120px",
                            backgroundColor: "white",
                            boxShadow: 3,
                            borderRadius: "8px",
                            zIndex: 1000
                        }}
                    >
                        <MenuItem onClick={() => navigate("/landingpagesubscription")}>Subscription </MenuItem>
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Paper>
                )}
            </AppBar>

            {/* ✅ Drawer (for Mobile Menu) */}
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                {DrawerContent}
            </Drawer>
        </>
    );
};

export default Tablesnavbar;
